import { render, staticRenderFns } from "./vinbetweentext.vue?vue&type=template&id=e365feb2&scoped=true&"
import script from "./vinbetweentext.vue?vue&type=script&lang=js&"
export * from "./vinbetweentext.vue?vue&type=script&lang=js&"
import style0 from "./vinbetweentext.vue?vue&type=style&index=0&id=e365feb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e365feb2",
  null
  
)

export default component.exports